import { Form } from "antd";
import React from "react";
import Input from "./BaseInput";

const WeightRangeField: React.FC = () => {
    return (
        <Form.Item label={<span className="search-field-label">重量(kg)</span>}>
            <div style={{ display: "flex" }}>
                <Form.Item name="minWeight" className="inline-block" style={{ marginRight: 0 }}>
                    <Input style={{ width: 45 }} />
                </Form.Item>
                <span className="to-label">至</span>
                <Form.Item name="maxWeight" className="inline-block" style={{ marginRight: 0 }}>
                    <Input style={{ width: 45 }} />
                </Form.Item>
            </div>
        </Form.Item>
    );
};

export default React.memo(WeightRangeField);
